import React from 'react' // , { useState }
import { Popup } from 'antd-mobile'
import PrizeItem from '../PrizeItem'
import './index.scss'

const PrizePopup = props => {
  const { stepList = [], maskVisible = false, prizeStep = 'A' ,popupHandle} = props

  return (
    <Popup
        className="prize-popup"
        onMaskClick={() => {
          popupHandle(false)
        }}
        visible={maskVisible}
    >
      <div className="prize-popup-wrap">
        <div className="popup-header">
          <div className="popup-title-box longer">
            <div className={`popup-title-text ${(prizeStep+'').length > 2 ? 'longer' : ''}`}>{prizeStep}奖详情</div>
          </div>
          <div
              className="popup-close"
              onClick={() => {
                popupHandle(false)
              }}
          ></div>
        </div>
        <div className="popup-content">
          {
            stepList.length > 0 ?
            stepList.map((item, key) => {
              return <PrizeItem
                  className="pop-prize-item"
                  item={item}
                  key={`step_card_${key}`}
                  prizeItemType={'popup'}
                  />
            })
          : <p className="loading">正在加载中...</p>
          }
        </div>
      </div>
    </Popup>
  )
}
export default PrizePopup
